import _ from "lodash";
window._ = _;

import Tether from "tether";
window.Tether = Tether;

/**
 * We'll load jQuery and the Bootstrap jQuery plugin which provides support
 * for JavaScript based Bootstrap features such as modals and tabs. This
 * code may be modified to fit the specific needs of your application.
 */
import jQuery from "jquery";
window.$ = window.jQuery = jQuery;
import 'popper.js';
import "bootstrap"
import '../css/lucide-icons.css';
import '../css/stage-card.css';

/**
 * Vue is a modern JavaScript library for building interactive web interfaces
 * using reactive data binding and reusable components. Vue's API is clean
 * and simple, leaving you to focus on building your next great project.
 */

import { createApp } from 'vue'
const app = createApp({})

/**
 * We'll load the axios HTTP library which allows us to easily issue requests
 * to our Laravel back-end. This library automatically handles sending the
 * CSRF token as a header based on the value of the "XSRF" token cookie.
 */

import "es6-promise/auto";
import axios from "axios";
window.axios = axios;

window.axios.defaults.headers.common["X-Requested-With"] = "XMLHttpRequest";
window.axios.defaults.withCredentials = true;

import "./locale/fr/dayjs";
import DayjsDuration from "dayjs/plugin/duration";
import DayjsLocalizedFormat from "dayjs/plugin/localizedFormat";
import DayjsIsSameOrAfter from "dayjs/plugin/isSameOrAfter";
import DayjsIsSameOrBefore from "dayjs/plugin/isSameOrBefore";
import DayjsUtc from "dayjs/plugin/utc";
import DayjsTimezone from "dayjs/plugin/timezone";
import DayjsRelativeTime from "dayjs/plugin/relativeTime";
import dayjs from "dayjs";

dayjs.extend(DayjsDuration);
dayjs.extend(DayjsLocalizedFormat);
dayjs.extend(DayjsIsSameOrAfter);
dayjs.extend(DayjsIsSameOrBefore);
dayjs.extend(DayjsUtc);
dayjs.extend(DayjsTimezone);
dayjs.extend(DayjsRelativeTime);

dayjs.locale(window.Laravel.locale || "en");

import { Model } from "vue-api-query";
// inject global axios instance as http client to Model
Model.$http = window.axios;

/**
 * Next we will register the CSRF Token as a common header with Axios so that
 * all outgoing HTTP requests automatically have it attached. This is just
 * a simple convenience so we don't have to attach every token manually.
 */

let token = document.head.querySelector('meta[name="csrf-token"]');

if (token) {
  window.axios.defaults.headers.common["X-CSRF-TOKEN"] = token.content;
} else {
  console.error(
    "CSRF token not found: https://laravel.com/docs/csrf#csrf-x-csrf-token",
  );
}

import Notifications from '@kyvg/vue3-notification'
app.use(Notifications);

// ES module-style import
import Bugsnag from "@bugsnag/js";
import BugsnagPluginVue from "@bugsnag/plugin-vue";

Bugsnag.start({
  apiKey: window.Laravel.bugsnagApiKey,
  plugins: [new BugsnagPluginVue()],
  releaseStage: window.Laravel.env,
  user: window.Laravel.user,
  enabledReleaseStages: [ 'production', 'staging' ]
});

Bugsnag.getPlugin("vue").installVueErrorHandler(app);

export default app;
